import a from "classnames";
import { useState as m } from "react";
import { jsx as u } from "react/jsx-runtime";
function p({
  src: r,
  darken: o,
  optimizable: t,
  optimizedImageComponent: e
}) {
  const [i, n] = m(!1);
  return r ? /* @__PURE__ */ u(e, {
    src: r,
    alt: "background",
    layout: "fill",
    objectFit: "cover",
    objectPosition: "center",
    priority: !0,
    className: a({
      darken: o
    }),
    onError: () => n(!0),
    unoptimized: !t || i ? !0 : void 0,
    quality: 100
  }) : null;
}
export {
  p as BackgroundImage
};
